import { render, staticRenderFns } from "./ContactRepCards.vue?vue&type=template&id=fdbbb5dc&scoped=true"
import script from "./ContactRepCards.vue?vue&type=script&lang=ts"
export * from "./ContactRepCards.vue?vue&type=script&lang=ts"
import style0 from "./ContactRepCards.vue?vue&type=style&index=0&id=fdbbb5dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbbb5dc",
  null
  
)

export default component.exports